import { render, staticRenderFns } from "./AwardNumbers.vue?vue&type=template&id=bf577b46&"
import script from "./AwardNumbers.vue?vue&type=script&lang=js&"
export * from "./AwardNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports